import { ButtonBase, styled, useTheme } from "@mui/material";
import { ReactNode } from "react";

interface CircleButtonProps {
  textColor?: string;
  color?: string;
  children?: ReactNode;
  onClick?: () => void;
  "aria-label"?: string;
  size?: number;
}

const StyledCircleButton = styled(ButtonBase)(({ color, theme }) => ({
  position: "relative",
  borderRadius: "50%",
  boxShadow: theme.shadows[0],
  color: 'inherit',
  backgroundColor: color ?? theme.palette.pink[500],
  transition: theme.transitions.create(
    ["background-color", "box-shadow", "border"],
    {
      duration: theme.transitions.duration.short,
    }
  ),
  "&:hover, &.Mui-focusVisible": {
    zIndex: 1,
    boxShadow: theme.shadows[3],
    "& .MuiImageBackdrop-root": {
      opacity: 0.15,
    },
    "& .MuiImageMarked-root": {
      opacity: 0,
    },
    "& .MuiTypography-root": {
      border: "4px solid currentColor",
    },
  },
}));

const CircleButton = ({
  color,
  textColor,
  children,
  onClick,
  "aria-label": ariaLabel,
  size = 64,
  ...props
}: CircleButtonProps) => {
  const theme = useTheme();

  return (
    <StyledCircleButton
      color={color}
      onClick={onClick}
      aria-label={ariaLabel}
      sx={{
        width: size,
        height: size,
        color: textColor || theme.palette.common.white,
      }}
      {...props}
    >
      {children}
    </StyledCircleButton>
  );
};

export default CircleButton;